import React, { PropsWithChildren, useMemo, useState } from 'react'

import { useMobile } from '@/hooks'
import { APP_TYPE } from '@/types/User'
import { APP_STORAGE_KEY } from '@/util'

import { Header } from './Header/Header'
import { Sidebar } from './Sidebar/Sidebar'

export function Navigation({ children }: PropsWithChildren<{}>) {
  const { isMobile, isTablet } = useMobile()
  const [minimizeSideBar, setMinimizeSideBar] = useState(true)
  const active_app = localStorage.getItem(APP_STORAGE_KEY)

  const smallScreen = useMemo(() => {
    return isMobile || isTablet
  }, [isMobile, isTablet])

  const activeApp = useMemo(() => {
    switch (active_app) {
      case 'support':
        return APP_TYPE.SUPPORT
      case 'sales':
        return APP_TYPE.SALES
      case 'settings':
        return APP_TYPE.SETTINGS
      case 'communications':
        return APP_TYPE.COMMUNICATIONS
      default:
        return APP_TYPE.SUPPORT
    }
  }, [active_app])

  const onToggle = () => {
    setMinimizeSideBar(!minimizeSideBar)
  }

  return (
    <>
      {activeApp && (
        <>
          <Header activeApp={activeApp} minimize={minimizeSideBar} toggleSideBar={onToggle} />
          <Sidebar
            activeApp={activeApp}
            minimize={minimizeSideBar}
            smallScreen={smallScreen}
            toggleSideBar={onToggle}
          />
        </>
      )}
      <div
        className={`mt-16 flex min-h-0 w-screen justify-between overflow-hidden md:mt-0 md:min-h-screen md:w-full md:justify-center md:overflow-auto ${
          minimizeSideBar ? 'md:ml-16' : 'md:ml-56'
        }`}
      >
        {children}
      </div>
    </>
  )
}
